module.exports = "/dist/images/40a7e1fc4fc0ae5e4c3b17feee7bb697-placeorder.jpg";